import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './Trainers.css';

const Trainers = () => {
  const trainers = [
    {
      name: 'Sarah Johnson',
      role: 'Hatha Yoga Expert',
      experience: '12+ Years Experience',
      quote: 'Helping you build strength, flexibility, and inner peace.',
      image: 'https://images.unsplash.com/photo-1518609878373-06d740f60d8b?auto=format&fit=crop&q=80&w=600'
    },
    {
      name: 'Emily Wilson',
      role: 'Vinyasa Flow Instructor',
      experience: '10+ Years Experience',
      quote: 'Guiding every movement with breath and positive energy.',
      image: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?auto=format&fit=crop&q=80&w=600'
    },
    {
      name: 'Olivia Davis',
      role: 'Meditation & Mindfulness Coach',
      experience: '8+ Years Experience',
      quote: 'Helping you achieve calmness and mental clarity.',
      image: 'https://images.unsplash.com/photo-1594381898411-846e7d193883?auto=format&fit=crop&q=80&w=600'
    },
    {
      name: 'Michael Brown',
      role: 'Power Yoga Specialist',
      experience: '9+ Years Experience',
      quote: 'Build endurance, focus, and a stronger body.',
      image: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?auto=format&fit=crop&q=80&w=600'
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { staggerChildren: 0.2 } }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
  };

  return (
    <section className="trainers">
      <div className="trainers-container">
        
        <motion.div 
          className="trainers-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
        >
          <h4 className="trainers-subtitle">OUR TRAINERS</h4>
          <h2 className="trainers-title">Meet Our Certified Yoga Experts</h2>
          <p className="trainers-desc">
            Passionate instructors dedicated to helping you grow with confidence and mindfulness.
          </p>
          <div className="trainers-divider"></div>
        </motion.div>

        <motion.div 
          className="trainers-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          {trainers.map((trainer, idx) => (
            <motion.div key={idx} className="trainer-card" variants={itemVariants}>
              <div className="trainer-photo-wrapper">
                <img src={trainer.image} alt={trainer.name} className="trainer-photo" />
                <div className="trainer-overlay">
                  <Link to="/appointment" className="btn-book-session">Book a Session</Link>
                </div>
              </div>
              
              <div className="trainer-content">
                <h3 className="trainer-name">{trainer.name}</h3>
                <h5 className="trainer-role">{trainer.role}</h5>
                <div className="trainer-experience">{trainer.experience}</div>
                <p className="trainer-quote">"{trainer.quote}"</p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Trainers;
